export const delay = ms => new Promise(res => setTimeout(res, ms));